<template>
  <div
    data-locale="en-US"
    data-style-height="20px"
    data-style-width="100%"
    data-businessunit-id="608c5c7e377e490001766887"
    :data-theme="theme"
    :data-template-id="templateId"
  >
    <a
      href="https://www.trustpilot.com/review/apricotinsurance.co.uk"
      target="_blank"
      rel="noopener"
    >
      Trustpilot
    </a>
  </div>
</template>

<script>
export default {
  name: 'trustpilot-widget-template',
  props: {
    theme: {
      type: String,
      required: true,
    },
    templateId: {
      type: String,
      required: true,
    },
  },
};
</script>
